import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { DishwasherId, DishwasherState } from './dishwasher.types';

import { ApplianceModel } from '~/core/models';
import { convertArrayToMap } from '~/redux/utils';

const initialState: DishwasherState = {
  browsedDishwashersById: {},
  selectedDishwasherId: undefined,
  inStoreDishwashersUrl: undefined,
};

const dishwasherSlice = createSlice({
  name: 'dishwasher',
  initialState,
  reducers: {
    updateBrowsedDishwashers: (
      state,
      action: PayloadAction<ApplianceModel[]>
    ) => {
      state.browsedDishwashersById = convertArrayToMap(
        action.payload,
        'productId'
      );
    },
    updateSelectedDishwasherId: (
      state,
      action: PayloadAction<DishwasherId>
    ) => {
      state.selectedDishwasherId = action.payload;
    },
    updateInStoreDishwashersUrl: (state, action: PayloadAction<string>) => {
      state.inStoreDishwashersUrl = action.payload;
    },
  },
});

export const {
  updateBrowsedDishwashers,
  updateSelectedDishwasherId,
  updateInStoreDishwashersUrl,
} = dishwasherSlice.actions;

export default dishwasherSlice.reducer;
